// @flow

import queryString from 'query-string';
import classNames from 'classnames';
import React from 'react';
import type { Node } from 'react';
import { Link } from '@riseart/common';
import { SearchIcon } from '@riseart/icons';
import { useUrlParams } from 'shared_data/providers/url/useUrlParams';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';
import { filterSearchLinkCls } from 'shared_components/common/filters/components/Search.less';

/**
 * FilterSearchLink
 *
 * @param {props} props
 * @returns {Node}
 */
export function FilterSearchLink({ children, className, ...props }: Object): Node {
  const { translatedLocation: location } = useUrlParams();
  const { pathname, search, hash } = location;
  const { q, v, l, page, ...restParams } = queryString.parse(search);
  const urlOptions = UrlAssembler.mergeOptions({ search: { ...restParams, q: '' } });

  // Text search is not available in combination with Visual and Lens searches
  return !v && !l ? (
    <Link
      className={classNames(filterSearchLinkCls, className)}
      to={`${pathname}${urlOptions.search}${hash}`}
      {...props}
    >
      {children || <SearchIcon />}
    </Link>
  ) : null;
}
